// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AboutUs from '../about-us/AboutUs';
import {actions} from '../duck';
import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    isSaving: state.legalConfig.isSaving,
    aboutUs: state.legalConfig.aboutUs,
    saveAboutUsError: state.legalConfig.saveAboutUsError,
    saveAboutUsSuccess: state.legalConfig.saveAboutUsSuccess,
    isFetchingAboutUs: state.legalConfig.isFetchingAboutUs,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(AboutUs);
